<template>
  <div v-if="!isSelectionEmpty">
    <app-action-bar
      :menu-items="actionBarItems"
      :selected-items="selectedDocuments"
      @clear-selection="onClearSelection"
    >
      <app-action-bar-list-item
        v-for="item in actionBarItems"
        :item="item"
        :key="item.name"
      />
    </app-action-bar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import AppActionBar from '@/common/app-action-bar/AppActionBar.vue'
import { useArchivesStore } from '@/stores/archivesStore'

export default {
  name: 'ArchivesBulkActions',
  components: {
    AppActionBar,
  },
  setup() {
    const archivesStore = useArchivesStore()
    return { archivesStore }
  },
  computed: {
    ...mapGetters('user', ['isArchivingAdmin', 'currentUserId']),
    selectedDocuments () {
      return this.archivesStore.selectedDocuments
    },
    isSelectionEmpty () {
      return this.selectedDocuments.length === 0
    },
    selectionCanBeDownloaded () {
      return this.isArchivingAdmin || this.selectedDocuments.every(document => document.canDownload)
    },
    actionBarItems () {
      return [
        {
          action: () => { this.onDownloadSelection() },
          icon: 'download',
          hidden: !this.selectionCanBeDownloaded,
          name: 'download',
          title: this.$t('common.download'),
        },
        {
          action: () => { this.onShareSelection() },
          icon: 'share',
          hidden: !this.isArchivingAdmin,
          name: 'share',
          title: this.$t('archives.ArchivesList.shareSelection'),
        },
        {
          action: () => { this.onSendSelection() },
          icon: 'email',
          name: 'email',
          title: this.$t('archives.ArchivesList.sendByEmail'),
        },
      ]
    },
  },
  beforeUnmount () {
    this.archivesStore.deselectAllDocuments()
  },
  methods: {
    onClearSelection () {
      this.archivesStore.deselectAllDocuments()
    },
    onDownloadSelection () {
      this.$emit('download-selection')
    },
    onShareSelection () {
      this.$emit('share-selection')
    },
    onSendSelection () {
      this.$emit('send-selection')
    },
  },
}
</script>
